/*
 * @Author: jiazhu.liu
 * @Date: 2022-07-29 10:27:44
 * @Last Modified by: jiazhu.liu
 * @Last Modified time: 2022-07-31 19:36:21
 */

import React from "react";

// 创建公共的Provider.Context
// 获取全局类通过xxxContext.Provider 包裹的可以获取到全局的值
// 定义一些全局的属性
// Context是用场景，主要是夸层级访问数据的场景，

export type ConfigConsumerProps = {
  getPrefixCls: (suffixCls?: string, customSumffixCls?: string) => string;
};

// 获取默认的前缀
const getDefaultPrefixCls = (suffixCls?: string, customSumffixCls?: string) => {
  if (customSumffixCls) return customSumffixCls;
  return suffixCls ? `react-ui-${suffixCls}` : "react-ui";
};

// 创建Config的Context
export const ConfigContext = React.createContext<ConfigConsumerProps>({
  getPrefixCls: getDefaultPrefixCls,
});

// 获取Consumer对象
export const ConfigConsumer = ConfigContext.Consumer;
